// Third party packages
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
// Custom packages
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
var SummaryDocsService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function SummaryDocsService(apiService, helperService) {
        this.apiService = apiService;
        this.helperService = helperService;
    }
    /**
     * Search docs of all condoStructure
     *
     * @since 1.0.0
     *
     * @param
     */
    SummaryDocsService.prototype.getSummaryDocs = function (search, properties) {
        var _this = this;
        var params = { search: search };
        if (Array.isArray(properties)) {
            Object.keys(properties).forEach(function (key) {
                var newParamKey = "properties[" + key + "]";
                var newParamValue = properties[key].id;
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService
            .apiCall("GET", "document-archives/summary-docs", params)
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Search docs of all condoStructure
     *
     * @since 1.0.0
     *
     * @param
     */
    SummaryDocsService.prototype.getSummaryDocsGeneral = function (search, data) {
        var _this = this;
        var params = { search: search };
        var properties = data ? data.properties : undefined;
        var users = data ? data.users : undefined;
        var company = data ? data.company : undefined;
        var subUsers = data ? data.subUsers : undefined;
        var startDate = data ? data.startDate : undefined;
        var endDate = data ? data.endDate : undefined;
        // Single field params
        // properties may be an intentional empty string (Immobili field left unselected) which must reach
        // the BE as properties=; only undefined/null mean "not provided". ApiService keeps empty strings.
        if (properties !== undefined && properties !== null) {
            params['properties'] = properties;
        }
        // users carries a sentinel ("-1" = all, "none" = nobody) or an operator id — never an empty
        // string, which the BE cannot tell apart from "not provided" and would treat as "no filter".
        if (users !== undefined && users !== null) {
            params['users'] = users;
        }
        if (company) {
            params['company'] = company;
        }
        // subUsers carries a sentinel ("-1" = all the company employees, "none" = no employee) or a
        // single employee userId; an empty string means "no employee filter" and is omitted.
        if (subUsers) {
            params['subUsers'] = subUsers;
        }
        if (startDate) {
            params['startDate'] = startDate;
        }
        if (endDate) {
            params['endDate'] = endDate;
        }
        return this.apiService
            .apiCall("GET", "document-archives/summary-docs-general", params)
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Search docs of all condoStructure
     *
     * @since 1.0.0
     *
     * @param
     */
    SummaryDocsService.prototype.getNextInsertionsGeneral = function (search, data) {
        var _this = this;
        var params = { search: search };
        var master = data ? data.master : undefined;
        var startDate = data ? data.startDate : undefined;
        var endDate = data ? data.endDate : undefined;
        // Single field params
        if (master) {
            params['master'] = master;
        }
        if (startDate) {
            params['startDate'] = startDate;
        }
        if (endDate) {
            params['endDate'] = endDate;
        }
        return this.apiService
            .apiCall("GET", "document-archives/summary-next-insertions", params)
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Get all properties
     *
     * @since 1.0.0
     *
     * @param
     */
    SummaryDocsService.prototype.getSummaryDocsProperties = function () {
        var _this = this;
        return this.apiService
            .apiCall("GET", "properties/get-all")
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Get all admin users
     *
     * @since 1.0.0
     *
     * @param
     */
    SummaryDocsService.prototype.getSummaryAdminUsers = function () {
        var _this = this;
        return this.apiService
            .apiCall("GET", "users/get-admin")
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Get all masters
     *
     * @since 1.0.0
     *
     * @param
     */
    SummaryDocsService.prototype.getSummaryDocsMasters = function () {
        var _this = this;
        return this.apiService
            .apiCall("GET", "companies/get-all")
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    SummaryDocsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SummaryDocsService_Factory() { return new SummaryDocsService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService)); }, token: SummaryDocsService, providedIn: "root" });
    return SummaryDocsService;
}());
export { SummaryDocsService };
